import React from 'react';
import classNames from 'classnames';

import Icon, { IconNames } from './presenter';

import { iconDefaultProps, iconPropTypes } from './iconPropTypes';


const ClearIcon = ({ className, size, ...rest }) => (
  <Icon
    className={classNames({
      'j-clear-icon': true,
      [className]: className,
    })}
    name={IconNames.CLEAR}
    size={size}
    {...rest}
  />
);

ClearIcon.propTypes = {
  ...iconPropTypes,
};

ClearIcon.defaultProps = {
  ...iconDefaultProps,
};


export default ClearIcon;
